import tippy from 'tippy.js';
import anime from 'animejs/lib/anime.es.js';
import debounce from 'lodash/debounce';

export default class HeaderMenu {
    constructor() {
        this.topLevelParent = document.querySelectorAll('.js-desktop-menu div > .menu-item-has-children');
        this.subMenuParent = document.querySelectorAll('.js-desktop-menu .header__subnav .menu-item-has-children');
        this.contentDimmer = document.querySelector('.js-content-dimmer');
        this.dimmerActive = false;

        this.init();
    }

    init() {
        this.topLevelParent.forEach(el => {
            tippy(el, {
                content: el.nextElementSibling,
                interactive: true,
                interactiveDebounce: 0,
                placement: 'bottom',
                maxWidth: 'none',
                allowHTML: true,
                hideOnClick: false,
                animation: 'shift-away-subtle',
                onTrigger: (instance) => {
                  setTimeout(() => {
                    if(document.querySelector('.js-content-dimmer.active') == null && el.matches(':hover')){
                      instance.show();
                    }
                  },100);
                },
                onShow: (instance) => {
                    if (this.dimmerActive) {
                        return false;
                    }

                    this.showDimmer();
                },
                onHide: () => {
                    if (!this.dimmerActive) {
                        return false;
                    }
                    this.hideDimmer();
                },
            });

        });

        this.subMenuParent.forEach(el => {

            tippy(el, {
                content: el.nextElementSibling,
                allowHTML: true,
                interactive: true,
                interactiveDebounce: 0,
                placement: 'right-start',
                offset: [0, 10],
                animation: 'shift-away-subtle',
                hideOnClick: false,
                onTrigger: (instance, event) => {
                    if (instance.reference.classList.contains('first-menu-item')) {
                        instance.reference.closest('.tippy-box').classList.add('first-submenu-active');
                    }
                },
                onUntrigger: (instance, event) => {
                    instance.reference.closest('.tippy-box').classList.remove('first-submenu-active');
                },
            });

        });

    }

    showDimmer() {
        this.contentDimmer.classList.add('active');
        this.dimmerActive = true;
    }

    hideDimmer () {
        this.contentDimmer.classList.remove('active');
        this.dimmerActive = false;
    }

}
